<template>
  <el-card class="user-content-panel">
    <div slot="header">
      <span class="panel-header">账号信息</span>
    </div>
    <div class="user-avatar">
      <img :src="avatarUrl">
    </div>
    <div class="user-opt-line">
      <FileUpload
        ref="avatarFileUpload"
        :show-file-list="false"
        :limit-size="500"
        :acceptFileType="'image/*'"
        class="avatar-upload"
        @beginUpload="onAvatarUploadBegin"
        @uploaded="onAvatarUploaded"
        :uploadImage = true>
        <el-button type="text" :loading="avatarLoading">更换头像</el-button>
      </FileUpload>
      <div class="password-reset">
        <el-button type="text" @click="resetPassword">重置密码</el-button>
      </div>

    </div>
    <div class="user-name">{{ info.clientName }}</div>

    <el-form :model="info" label-position="right" label-width="100px" class="user-form">
      <el-row>
        <el-col :span="12">
          <el-form-item label="用户账号">
            <span>{{ info.loginAccount }}</span>
          </el-form-item>
          <el-form-item label="所属事业部">
            <span>{{ info.clientBu }}</span>
          </el-form-item>
          <el-form-item label="所属区域">
            <span>{{ info.clientRegion }}</span>
          </el-form-item>
          <el-form-item label="邮箱">
            <span>{{ info.clientMail }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" class="phone">
            <el-input v-if="modifyPhone" :disabled="true" v-model="info.clientMobile" placeholder="请输入电话">
              <template slot="append">
                <el-button @click="editPhone">修改</el-button>
              </template>
            </el-input>
            <el-input v-else v-model="newPhone" placeholder="请输入电话">
              <template slot="append">
                <el-button type="primary" class="edit-phone-btn" @click="savePhone">保存</el-button>
                <el-button type="primary" @click="cancelEditPhone">取消</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="员工名称">
            <span>{{ info.clientName }}</span>
          </el-form-item>
          <el-form-item label="英文名称">
            <span>{{ info.englishName }}</span>
          </el-form-item>
          <el-form-item label="员工编号">
            <span>{{ info.employeeCode }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- <div class="button-line">
      <el-button type="primary" plain @click="editUserInfo">编辑用户信息</el-button>
    </div> -->
    <ResetPassword ref="reset-password" />
  </el-card>
</template>

<script>
import ResetPassword from './components/reset-password'
import FileUpload from '@/components/file-upload'
import { mapGetters } from 'vuex'
import userApi from '@/api/user'
import { commonUtils } from '@/utils/common'
export default {
  name: 'account-info',
  components: {
    FileUpload,
    ResetPassword
  },
  data () {
    return {
      info: {},
      modifyPhone: true,
      newPhone: '',
      avatarLoading: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    avatarUrl () {
      const defaultAvatar = require('../../assets/images/default-avatar.png')
      return commonUtils.getImageUrl(this.userInfo.avatarImageUri, defaultAvatar)
    }
  },
  created () {
    this.queryClientInfo()
  },
  methods: {
    queryClientInfo () {
      const clientId = this.userInfo.clientId
      if (!clientId) {
        return
      }
      userApi.queryClientInfo(clientId).then(res => {
        if (res.data.resultCode === '0') {
          this.info = res.data.resultData.clientInfo
        }
      })
    },
    // 开始上传头像
    onAvatarUploadBegin () {
      this.avatarLoading = true
    },
    // 上传头像完成
    onAvatarUploaded (file) {
      this.avatarLoading = false
      const payload = {
        avatarImageId: file.fileId,
        avatarImageUri: file.fileUri
      }
      this.$refs.avatarFileUpload.clearFileList()
      userApi.updateClientAvatar(payload).then(res => {
        if (res.data.resultCode === '0') {
          const newUserInfo = Object.assign({}, this.userInfo, { avatarImageId: file.fileId, avatarImageUri: file.fileUri })
          this.$store.commit('UPDATE_USER_INFO', newUserInfo)
        }
      })
    },
    editPhone () {
      // this.$router.push('/user/account/edit')
      this.modifyPhone = false
    },
    resetPassword () {
      this.$refs['reset-password'].show()
    },
    // 保存联系电话
    savePhone () {
      if (!(/^1[3456789]\d{9}$/.test(this.newPhone))) {
        this.$message.error('请输入正确的电话号码')
        return
      }
      this.info.clientMobile = this.newPhone
      userApi.updateClientInfo(this.info).then(res => {
        if (res.data.resultCode === '0') {
          this.$message.success('修改成功')
          this.modifyPhone = true
          this.queryClientInfo()
        }
      })
    },
    cancelEditPhone () {
      this.modifyPhone = true
      // this.queryClientInfo()
    }
  }
}
</script>

<style lang="scss" scoped>
.user-content-panel {
  .user-avatar {
    padding: 10px 0 0 0;
    overflow: hidden;
    text-align: center;
    img {
      width: 80px;
      height: 80px;
      border: 2px solid $base-grey;
      border-radius: 50%;
    }
  }

  .user-opt-line {
    display: flex;
    .avatar-upload {
      flex: 1;
      text-align: right;
      margin: 5px 10px;
    }
    .password-reset {
      flex: 1;
      text-align: left;
      margin: 5px 10px;
    }
  }
  .user-name {
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    padding: 0 0 16px 0;
  }

  .user-form {
    width: 90%;
    margin: 0 auto;

    ::v-deep .el-form-item__content {
      background-color: $base-grey5;
      padding-left: 10px;
      border-radius: 5px;
    }
  }

  .button-line {
    text-align: center;
  }

  .phone {
    padding-left: 0px !important;
    .edit-phone-btn {
      &::after {
        content: '';
        width: 1px;
        height: 100%;
        background-color: #DCDFE6;
        position: absolute;
        top: 0;
        right: 50%;
      }
    }
  }
}
</style>
